import React from 'react'
import {Flex} from '/app/src/component'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal';


import Customization from './Customization';
import User from './User';

class Wizard extends React.Component {
    constructor(props) {
        super(props);

        this._renderWizard = this._renderWizard.bind(this);
    }


    _renderWizard(name, closeModal){
        switch(name){
            case 'user':
                return <User closeModal={closeModal}/>
            case 'customization':
                return <Customization closeModal={closeModal}/>
            default:
                return(
                    <Flex>Create a wizard for this</Flex>
                )
        }
    }

    render(){

        let { name, open, closeModal }= this.props;

        return(
            <Modal styles={{modal: {borderRadius: '25px'}}} closeOnEsc={true} open={open} onClose={this.props.closeModal} showCloseIcon={false}>
                <Flex w='700px' h='350px' borderRadius='20px'>
                    {this._renderWizard(name, closeModal)}
                </Flex>
            </Modal>
        )
    }
}

function mapStateToProps(state, ownProps)
{
    return {

    };
}

export default connect(mapStateToProps)(Wizard);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Tutorial/Wizard/index.js